import axios from "axios"; // ✅ Correct
import { toast } from "react-toastify";

// Constants (You should define these properly or import them)
const APP_LINK_ANDROID = "https://play.google.com/store/apps/details?id=com.example";
const APP_LINK_IOS = "https://apps.apple.com/app/id0000000000";
const APP_NAME = "Study Smart";
const APP_VERSION_ANDROID = 1;
const APP_VERSION_IOS = 1;

const WEB_SERVICES = () => {
  return process.env.REACT_APP_API_URL;
};

const showToast = (msg) => alert(msg || "Something went wrong");

function instance(options = {}) {
  const token = localStorage.getItem("token") || "";

  const axiosClient = axios.create({
    baseURL: WEB_SERVICES(), //`${WEB_SERVICES}`,
    timeout: options?.timeout || 30000,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      ...options.headers,
    },
  });

  // // Response Interceptor
  // axiosClient.interceptors.response.use(
  //   (response) => response, // pass successful response through
  //   (error) => {
  //     // Log full error
  //     console.error("Axios Error:", error);

  //     if (error.response) {
  //       console.error("Response status:", error.response.status);
  //       console.error("Response data:", error.response.data);
  //     } else if (error.request) {
  //       console.error("No response received:", error.request);
  //     } else {
  //       console.error("Error message:", error.message);
  //     }

  //     // Always attach a normalized message
  //     error.normalizedMessage = error?.response?.data?.message || "The servers are not available!";

  //     // Reject so it can still be caught in your try/catch
  //     return Promise.reject(error);
  //   }
  // );

  return axiosClient;
}

function errorHandling(error) {
  console.error("Full error object:", error);

  if (error.response) {
    // Server responded with a status code outside 2xx
    console.error("Response status:", error.response.status);
    console.error("Response data:", error.response.data);
    console.error("Response headers:", error.response.headers);
  } else if (error.request) {
    // Request was made but no response
    console.error("No response received:", error.request);
  } else {
    // Something else went wrong
    console.error("Error message:", error.message);
  }

  const message =
    error?.response?.data?.message ||
    error?.response?.data?.msg ||
    "The servers are not available!";
  // showToast(message);
  toast.warning(message);

  if (error?.response?.status === 401) {
    resetDetail();
    window.location.href = "/authentication/admin-sign-in";
  }
}

export const resetDetail = () => {
  localStorage.removeItem("user");
  localStorage.removeItem("token");
  localStorage.removeItem("isEmployee");
};

function checkVersionUpdate(res) {
  return false;
}

//AUTHENTICATION
export const adminLogin = async (params) => {
  try {
    const res = await instance().post("auth/admin-login", JSON.stringify(params.params));

    return res?.data;
  } catch (error) {
    if (error?.response?.status === 400) {
      showToast("Invalid credentials");
    } else {
      errorHandling(error);
    }
    return;
  }
};
export const updateAdmin = async (params) => {
  try {
    const res = await instance().put("auth/update-admin", JSON.stringify(params.params));

    return res?.data;
  } catch (error) {
    errorHandling(error);

    return;
  }
};
export const adminChangePassword = async (params) => {
  try {
    const res = await instance().put("auth/admin-change-password", JSON.stringify(params.params));

    return res?.data;
  } catch (error) {
    errorHandling(error);

    return;
  }
};

//DASHBOARD
export const getDashboardCount = async (params) => {
  try {
    const res = await instance().get("fair/dashboard-count", params);

    return res?.data?.data;
  } catch (error) {
    errorHandling(error);
    return;
  }
};

//FAIR
export const getAllFair = async (params) => {
  try {
    const res = await instance().get("fair/get-all-fair?", params);

    return res?.data?.data;
  } catch (error) {
    errorHandling(error);
    return error;
  }
};
export const createFair = async (params) => {
  try {
    const res = await instance().post("fair/create-fair", JSON.stringify(params.params));

    return res?.data;
  } catch (error) {
    errorHandling(error);

    return;
  }
};

export const updateFair = async (params) => {
  try {
    const res = await instance().put(
      `fair/update-fair/${params?.id}`,
      JSON.stringify(params.params)
    );

    return res?.data;
  } catch (error) {
    errorHandling(error);

    return;
  }
};

export const deleteFair = async (params) => {
  try {
    const res = await instance().delete(`fair/delete-fair/${params?.id}`);

    return res?.data;
  } catch (error) {
    errorHandling(error);
    return;
  }
};

//LOCATION
export const getAllLocation = async (params) => {
  try {
    const res = await instance().get("location/get-all-location?", params);

    return res?.data?.data;
  } catch (error) {
    errorHandling(error);
    return error;
  }
};
export const getAllLocationList = async (params) => {
  try {
    const res = await instance().get("location/get-all-location-list?", params);

    return res?.data?.data;
  } catch (error) {
    errorHandling(error);
    return error;
  }
};
export const createLocation = async (params) => {
  try {
    const res = await instance().post("location/create-location", JSON.stringify(params.params));

    return res?.data;
  } catch (error) {
    errorHandling(error);

    return;
  }
};

export const updateLocation = async (params) => {
  try {
    const res = await instance().put(
      `location/update-location/${params?.id}`,
      JSON.stringify(params.params)
    );

    return res?.data;
  } catch (error) {
    errorHandling(error);

    return;
  }
};

export const deleteLocation = async (params) => {
  try {
    const res = await instance().delete(`location/delete-location/${params?.id}`);

    return res?.data;
  } catch (error) {
    errorHandling(error);
    return;
  }
};

//USER
export const getAllUser = async (params) => {
  try {
    const res = await instance().get("user/get-all-user?", params);

    return res?.data?.data;
  } catch (error) {
    errorHandling(error);
    return error;
  }
};
export const createUser = async (params) => {
  try {
    const res = await instance().post("user/create-user", JSON.stringify(params.params));

    return res?.data;
  } catch (error) {
    errorHandling(error);

    return;
  }
};

export const updateUser = async (params) => {
  try {
    const res = await instance().put(
      `user/update-user/${params?.id}`,
      JSON.stringify(params.params)
    );

    return res?.data;
  } catch (error) {
    errorHandling(error);

    return;
  }
};

export const deleteUser = async (params) => {
  try {
    const res = await instance().delete(`user/delete-user/${params?.id}`);

    return res?.data;
  } catch (error) {
    errorHandling(error);
    return;
  }
};

//REGISTRATION
export const getAllRegistration = async (params) => {
  try {
    const res = await instance().get("registration/get-all-registration?", params);

    return res?.data?.data;
  } catch (error) {
    errorHandling(error);
    return error;
  }
};

export const updateRegistration = async (params) => {
  try {
    const res = await instance().put(
      `registration/update-registration/${params?.id}`,
      JSON.stringify(params.params)
    );

    return res?.data;
  } catch (error) {
    errorHandling(error);

    return;
  }
};

export const getAllCheckIn = async (params) => {
  try {
    const res = await instance().get("registration/get-all-check-in?", params);

    return res?.data?.data;
  } catch (error) {
    errorHandling(error);
    return error;
  }
};

//PROFILE
export const getProfile = async (params) => {
  try {
    const res = await instance().get(`user/user-profile/${params?.id}`, params);

    return res?.data?.data;
  } catch (error) {
    errorHandling(error);
    return error;
  }
};

//DELETE ACCOUNT
export const deleteAccount = async (params) => {
  try {
    const res = await instance().post("auth/delete-account", JSON.stringify(params.params));

    return res?.data;
  } catch (error) {
    if (error?.response?.status === 400) {
      showToast("Invalid credentials");
    } else {
      errorHandling(error);
    }
    return;
  }
};

export const verifyDeleteAccount = async (params) => {
  try {
    const res = await instance().post(
      "auth/verify-delete-account-otp",
      JSON.stringify(params.params)
    );

    return res?.data;
  } catch (error) {
    if (error?.response?.status === 400) {
      showToast("Invalid credentials");
    } else {
      errorHandling(error);
    }
    return;
  }
};

//UPLOAD

export const uploadFile = async (params) => {
  try {
    // console.log("______params______", params);
    const formData = new FormData();
    formData.append("file", params?.file); // field name must match multer.single("file")

    const res = await instance().post("upload/upload-file", formData, {
      headers: { "Content-Type": "multipart/form-data" },
      timeout: 10 * 60 * 1000,
      onUploadProgress: (evt) => {
        if (!evt.total) return;
        const pct = Math.round((evt.loaded * 100) / evt.total);
        // console.log("Upload Progress:", pct, "%");
      },
    });
    // console.log("______res___0___", res);

    return res?.data;
  } catch (error) {
    errorHandling(error);
    return null;
  }
};

//SEND REMINDER
export const sendReminder = async (params) => {
  try {
    const res = await instance().get("registration/send-reminder?", params);

    return res?.data?.data;
  } catch (error) {
    errorHandling(error);
    return error;
  }
};
